export default __webpack_public_path__ + "static/media/portfolio.e37eed4a.png";